export default __webpack_public_path__ + "static/media/ladakh.799b549f.jpeg";